<template>
  <div class="main-container">
    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => toast = val"
    />
    <breadcrumb :list="breadcrumbList" />

    <tl-header type="h1">
      <div class="main-header margintop-30">Process FBP for the Month</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="lockUnlockHide">
      Please Lock/Unlock FBP process.
      <br />
      <br />
      <btn 
        text="Back" 
        type="secondary" 
        @click="back" />
    </div>
    <tl-select
      class="col-4"
      label="Generation Type"
      placeholder="Select Generation Type"
      labelText="generationName"
      :options="generationList"
      v-model="generationType"
      @change="(val)=>onSelectGenerationType(val)"
      :disabled="lockUnlockDisabled"
    />
    <br />
    <div v-if="generationType == 'Employee Wise'">
      <div class="col-4">
        <search-dropdown
          placeholder="Search Employee"
          :employeeData="employeeData"
          :clearRequired="true"
          @getList="searchEmployeesByName($event)"
          @empselected="(emp) => selectedEmp(emp)"
        />
      </div>
      <br />
      <div class="col-4">
        <selected-employee-card
            v-if="showEmpDetails"
            :empPhotoUrl="data.photo_url"
            :empName="data.first_name"
            :empId="data.code"
            :dates="data.rlopdates"
            :empMail="data.email_id"
            @click="close"
        >
        </selected-employee-card>
        <br />
      </div>
    </div>
    <tl-select
      class="col-4 text-capital"
      label="Month"
      placeholder="Select Month"
      :options="monthList"
      v-model="formData.month"
      @change="(val) => (formData.month = val)"
      :disabled="lockUnlockDisabled"
    />
    <br />
    <tl-select
      class="col-4"
      label="Year"
      placeholder="Select Year"
      :options="yearList"
      v-model="formData.year"
      @change="(val) => (formData.year = val)"
      :disabled="lockUnlockDisabled"
    />
    <br />
    <!-- <tl-select
      v-if="generationType == 'All Employees'"
      class="col-4 text-capital" 
      label="Location" 
      placeholder="Select Location" 
      labelText="name"
      :options="locationList"
      @change="(val)=>formData.location = val.name">
    </tl-select> -->
    <br />
    
    <pop-up-message
      v-if="showSuccessMsg"
      :message="responseMsg"
      btnText="Back"
      @back="backfrompopup"
    ></pop-up-message>
    <bottom-action-container class="custom-width">
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn text="Process" type="primary" @click="process" :disabled="lockUnlockDisabled" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";

export default {
  components: {
    SearchDropdown,
    selectedEmployeeCard,
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
        },
        {
          name: "Process FBP for the Month",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
      ],
      monthList: [],
      yearList:[],
      generationList: [
        {
          generationName: "All Employees",
          value: "all",
        },
        {
          generationName: "Employee Wise",
          value: "empwise",
        },
      ],
      formData: {
        month: "",
        year: "",
        //location: "",
      },
      showEmpDetails: false,
      data: {},
      employeeData: [],
      emp_id: null,
      locationList: [],
      generationType:"",
      errmsg: "",
      showSuccessMsg: false,
      toast: false,
      monthDate: "",
      yearDate: "",
      lockUnlockHide: false,
      lockUnlockDisabled: false
    };
  },
  mounted() {
    //this.fetchAll();
  },
  activated(){
    this.getLocations();
    this.fetchAll();
  },
  computed: {
    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },
    ...mapState("onboard/organization", {
      orgId: (state) => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" ||
        this.role === "ADMIN"
      ) {
        if (this.companyValue) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      act_create:"dashboard/payroll/utilities/fbpProcessMonth/createForSingleEmp",
      act_create_all:"dashboard/payroll/utilities/fbpProcessMonth/createForAllEmp", 
      fetch_locations:"onboard/locations/fetchAll",
      fetchAll_list: "dashboard/payroll/utilities/fbpProcessMonth/fetchAll" 
    }),

    /** Function to fetch the locations list from server */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error); 
      }
    },

    async fetchAll() {
     try{
        let res = await this.fetchAll_list({
         le_id: this.le_id,
          month: this.payrollMonth.toLowerCase().slice(0,3),
          //month: this.payrollMonth.toLowerCase(),     
          year: this.payrollYear
       });
       if(res.data.payload && res.data.payload.data.length > 0) {
        this.monthDate = res.data.payload.data[0].month;
        this.yearDate = res.data.payload.data[0].year;
       } else {
         this.lockUnlockHide = true;
         this.lockUnlockDisabled = true;
       }
       
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val,
        });
        this.employeeData = res.data.payload;
        this.emp_id = res.data.payload[0].id;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async selectedEmp(emp) {
      try {
        this.data = emp;
        //this.emp_id = emp.id;
        this.formData.le_id = this.le_id;
        this.showEmpDetails = true;
        this.formData.employee_id = this.data.id;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    onSelectGenerationType(e) {
      this.generationType = e.generationName;
      this.monthList = this.monthDate;
      this.yearList = this.yearDate.toString();
      this.formData.month = this.monthDate.toLowerCase().slice(0, 3);
      //this.formData.month = this.monthDate.slice(0, 3).toLowerCase();
      this.formData.year = this.yearDate;
    },

    close() {
      this.showEmpDetails = false;
    },

    async process() {
      try {
        if(this.generationType == "All Employees"){
          this.formData.le_id = this.le_id;
          let res = await this.act_create_all(this.formData);
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.data.message;
          }
        } else {
          let res = await this.act_create(this.formData);
          if(res == undefined) {
            this.responseMsg = `FBP already has been processed for ${this.data.first_name}`;
             this.toast = true;
             this.errmsg = this.responseMsg;
          } else {
              if (res.data && res.data.status) {
              this.responseMsg = res.data.message ? res.data.message : "";
              this.showSuccessMsg = true;
            } else {
              this.toast = true;
              this.errmsg = res.data.message;
            }
          }
        }
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`
      });
      this.showEmpDetails = false;
      this.resetForm();
    },

    /* function to hide successpop-up and go back to main cost centre page */
    backfrompopup() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpPayroll`,
      });
      this.resetForm();
    },
    resetForm() {
      try {
        this.formData = {
          month: '',
          year: '',
          //location: ''
        };
        this.generationType = ""
        this.showEmpDetails = false;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(4, minmax(180px, 1fr));
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 5%;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #6e6e6e;
}
.btn-center {
  margin: auto;
}
.input-checkbox {
  height: 20px;
  width: 20px;
}
.dropdown-box-design {
  border: 1px solid #e7e7e7;
  padding: 20px 4px 20px 20px;
  border-radius: 3px;
  background: #f9f9f9;
  max-width: 300px;
}
.text-capital {
  text-transform: capitalize;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 2px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>